import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiArrowRight, FiActivity } = FiIcons;

const Hero = () => {
  return (
    <section className="pt-32 pb-24 bg-[#2c3a50] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-[#c5a059] blur-[150px] rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#c5a059] blur-[120px] rounded-full translate-x-1/2 translate-y-1/2"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-6 py-2 mb-10">
            <SafeIcon icon={FiActivity} className="text-[#c5a059]" />
            <span className="text-white/90 font-bold text-[10px] tracking-[0.1em] uppercase">Sementinha – Os primeiros passos para um desenvolvimento emocional saudável</span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-10 leading-[1.1] tracking-tight">
            Parentalidade consciente:<br />
            <span className="text-[#c5a059]">pais e mães tranquilos, filhos emocionalmente saudáveis</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-300 mb-14 max-w-5xl mx-auto leading-relaxed font-medium">
            Entenda como a Terapia Cognitivo-Comportamental e a Terapia do Esquema podem ajudar você a construir uma relação mais saudável com seu filho e promover um desenvolvimento emocional mais equilibrado
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a 
              href="https://pay.kiwify.com.br/IotGhts" 
              target="_blank" 
              rel="noopener noreferrer"
              className="group flex items-center justify-center bg-[#c5a059] text-white px-12 py-6 rounded-full text-xl font-black hover:bg-white hover:text-[#2c3a50] transition-all transform hover:scale-105 shadow-[0_20px_40px_rgba(0,0,0,0.4)]"
            >
              QUERO MEU FILHO EMOCIONALMENTE SAUDÁVEL
              <SafeIcon icon={FiArrowRight} className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;